import { API_BASE_URL } from '../config/env';

export const getImageUrl = (url: string | null | undefined): string | undefined => {
    if (!url) return undefined;
    if (url.startsWith('http') || url.startsWith('blob:')) return url;

    // Удаляем слэш в начале url, если он есть, чтобы избежать двойного слэша
    const cleanUrl = url.startsWith('/') ? url.substring(1) : url;
    // Удаляем слэш в конце API_BASE_URL, если он есть
    const cleanBaseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;

    return `${cleanBaseUrl}/${cleanUrl}`;
};
